export const SUB_AGENT_LIST_REQUEST = "SUB_AGENT_LIST_REQUEST";
export const SUB_AGENT_LIST_SUCCESS = "SUB_AGENT_LIST_SUCCESS";
export const SUB_AGENT_LIST_FAIL = "SUB_AGENT_LIST_FAIL";
export const SUB_AGENT_LIST_RESET = "SUB_AGENT_LIST_RESET";

export const SUB_AGENT_CREATE_REQUEST = "SUB_AGENT_CREATE_REQUEST";
export const SUB_AGENT_CREATE_SUCCESS = "SUB_AGENT_CREATE_SUCCESS";
export const SUB_AGENT_CREATE_FAIL = "SUB_AGENT_CREATE_FAIL";
export const SUB_AGENT_CREATE_RESET = "SUB_AGENT_CREATE_RESET";

export const SUB_AGENT_GET_REQUEST = "SUB_AGENT_GET_REQUEST";
export const SUB_AGENT_GET_SUCCESS = "SUB_AGENT_GET_SUCCESS";
export const SUB_AGENT_GET_FAIL = "SUB_AGENT_GET_FAIL";
export const SUB_AGENT_GET_RESET = "SUB_AGENT_GET_RESET";

export const SUB_AGENT_UPDATE_REQUEST = "SUB_AGENT_UPDATE_REQUEST";
export const SUB_AGENT_UPDATE_SUCCESS = "SUB_AGENT_UPDATE_SUCCESS";
export const SUB_AGENT_UPDATE_FAIL = "SUB_AGENT_UPDATE_FAIL";
export const SUB_AGENT_UPDATE_RESET = "SUB_AGENT_UPDATE_RESET";

export const SUB_AGENT_DELETE_REQUEST = "SUB_AGENT_DELETE_REQUEST";
export const SUB_AGENT_DELETE_SUCCESS = "SUB_AGENT_DELETE_SUCCESS";
export const SUB_AGENT_DELETE_FAIL = "SUB_AGENT_DELETE_FAIL";

export const SUB_AGENT_VERIFY_STATUS_REQUEST =
  "SUB_AGENT_VERIFY_STATUS_REQUEST";
export const SUB_AGENT_VERIFY_STATUS_SUCCESS =
  "SUB_AGENT_VERIFY_STATUS_SUCCESS";
export const SUB_AGENT_VERIFY_STATUS_FAIL = "SUB_AGENT_VERIFY_STATUS_FAIL";

export const SUB_AGENT_VERIFY_ACTION_REQUEST =
  "SUB_AGENT_VERIFY_ACTION_REQUEST";
export const SUB_AGENT_VERIFY_ACTION_SUCCESS =
  "SUB_AGENT_VERIFY_ACTION_SUCCESS";
export const SUB_AGENT_VERIFY_ACTION_FAIL = "SUB_AGENT_VERIFY_ACTION_FAIL";
export const SUB_AGENT_VERIFY_ACTION_RESET = "SUB_AGENT_VERIFY_ACTION_RESET";
